import React from "react";
import { Box, Container, Grid, Typography, useMediaQuery } from "@mui/material";
import theme from "../../../theme/Theme";
import TopLeft from "../../../assets/svg/TopLeft";
import BottomRight from "../../../assets/svg/BottomRight";

const HowItWorks = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <Box
      component={"section"}
      style={isMobile ? styles.howItWorksMobile : styles.howItWorks}
    >
      <Box sx={styles.topRightBg}>
        <TopLeft />
      </Box>

      <Container maxWidth="lg" sx={styles.contentWrapper}>
        <Typography sx={styles.sectionTitle}>
          How It <span style={styles.titleHighLight}>Works</span>
        </Typography>

        <Grid container spacing={4} sx={styles.howItWorksContainer}>
          <Grid item xs={12} md={6}>
            <Box sx={styles.stepsList}>
              {steps.map((step, index) => (
                <Box key={index} sx={styles.buttonWrapper}>
                  <Box sx={styles.step}>
                    <Box sx={styles.stepNumber}>{index + 1}</Box>
                    <Box sx={styles.stepContent}>
                      <Typography sx={styles.stepTitle}>
                        {step.title}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={styles.videoContainer}>
              <Box sx={styles.videoWrapper}>
                <img
                  src="https://shorturl.at/gD4Rn"
                  alt="Referral video Preview"
                  style={styles.videoImage}
                />
                <Box sx={styles.playButton}>
                  <Box sx={styles.playIcon}>▶</Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>

      <Box sx={styles.bottomRightBg}>
        <BottomRight />
      </Box>
    </Box>
  );
};

const steps = [
  { title: "Connect Wallet" },
  { title: "Get the Referral Link" },
  { title: "Check your wallet for income" },
  { title: "Earn multiple-level income over time" },
];

const styles = {
  section: {
    padding: { xs: "60px 0", md: "100px 0" },
    position: "relative",
    overflow: "hidden",
  },
  topRightBg: {
    position: "absolute",
    top: 0,
    left: 0,
  },
  bottomRightBg: {
    position: "absolute",
    right: 0,
    bottom: 0,
  },
  contentWrapper: {
    position: "relative",
    zIndex: 2,
  },
  sectionTitle: {
    fontWeight: "800",
    margin: "0.2em 2em 0.5em 1em",
    paddingTop: "1em",
    fontSize: { xs: "5.5vw", lg: "3.2vw" },
    textAlign: "center",
    color: theme.custom.black,
    textTransform: "uppercase",
    zIndex: 3,
    position: "relative",
  },
  titleHighLight: {
    color: theme.palette.primary.main,
    borderBottom: "1.5px solid rgba(0, 0, 0, 1)",
  },
  howItWorksContainer: {
    position: "relative",
    zIndex: 3,
  },
  stepsList: {
    display: "flex",
    flexDirection: "column",
    gap: "1em",
  },
  buttonWrapper: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: "12px",
    padding: "0.15em",
    // width: "fit-content",
    maxWidth: "100%",
    // marginTop: { xs: "0.4em", sm: "1em", md: "1.5em" },
    // marginBottom: "1em",
  },
  step: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    padding: "15px 20px",
    backgroundColor: theme.custom.white,
    borderRadius: "10px",
  },
  stepNumber: {
    width: "40px",
    height: "40px",
    backgroundColor: theme.palette.primary.main,
    color: theme.custom.white,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: "1.2rem",
    flexShrink: 0,
  },
  stepContent: {
    flex: 1,
  },
  stepTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  videoContainer: {
    display: "flex",
    justifyContent: "center",
  },
  videoWrapper: {
    marginTop: "1em",
    position: "relative",
    borderRadius: "20px",
    overflow: "hidden",
    boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
    maxWidth: "100%",
  },
  videoImage: {
    width: "100%",
    height: "auto",
    display: "block",
  },
  playButton: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80px",
    height: "80px",
    backgroundColor: "rgba(255,255,255,0.9)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: theme.custom.white,
      transform: "translate(-50%, -50%) scale(1.1)",
    },
  },
  playIcon: {
    color: theme.palette.primary.main,
    fontSize: "2rem",
  },
  howItWorks: {
    position: "relative",
    minHeight: "100vh",
    top: "-0.5em",
  },
  howItWorksMobile: {
    position: "relative",
    top: "-2em",
    minHeight: "100vh",
  },
};

export default HowItWorks;
